import {
  validateRequired,
  validateNonZeroInteger,
  validateDateRange,
  validateNotNull,
  validateSelectInteger,
  validateInteger,
  validateStartDate
} from "../../../../helpers/validationsForm";

const Inputs = (id) => {
  // Verifica si es un modo de edición
  const isEditing = id > 0;
  return [{
      id: String(1), // Convertido a string
      label: "Nombre De La Lista de Precio",
      name: "lp_descripcion",
      type: "text",
      placeholder: "Ingrese el nombre",
      validation: (value) => validateRequired(value),
      cssClass: (errors, name) => errors[name] ? 'is-invalid' : 'default-class',
    },
    {
      id: String(2), // ID del campo
      label: "Tipo De Precio", // Etiqueta visible en el formulario
      name: "lp_tipo_precio", // Nombre asociado al campo
      type: "select", // Tipo de input
      placeholder: "Seleccione el tipo de precio", // Texto de ayuda cuando el campo está vacío
      validation: (value) => {
        
    
        // Sin errores
        return null;
      },
      
    },
    {
      id: String(3), // ID del campo
      label: "Porcentaje", // Etiqueta visible en el formulario´
      name: "lp_porc", // Nombre asociado al campo
      type: "number", // Tipo de input
      placeholder: "Ingrese el porcentaje", // Texto de ayuda cuando el campo está vacío
      validation: (value) => {
        // Validación para el valor ingresado
        if (value === null || value === undefined || value === "") {
          return "El porcentaje es obligatorio."; // Mensaje de error si el campo está vacío
        }
      }
    }
    ,
        {
    id: String(6),
    label: "Mostrar en Web",
    name: "lp_show_web",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
   {
    id: String(7),
    label: "Mostrar en App",
    name: "lp_show_app",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },

     
    
  ];
};

export default Inputs;